import React from "react";
import { ProductConsumer } from "../../../Context/AddProWakel";
const FillDetailQarzRastawxo = () => {
  return (
    <>
      <ProductConsumer>
        {(value) => {
          const { QR_from, QR_to, AddProChange, QR_name } = value;
          return (
            <>
              <div className="row" style={{ backgroundColor: "#2C3539" }}>
                <div className="col-lg-3  col-4 form-inline">
                  <div className="row form-inline">
                    <div className="col-6 form-inline">
                      <p
                        className="font-weight-bold bg-white  f3"
                        style={{ color: "#000" }}
                      ></p>
                      <span style={{ color: "#2C3539" }}>:</span>
                      <p
                        className="font-weight-bold bg-white  f4"
                        style={{ color: "#000" }}
                      >
                        {QR_from}
                      </p>
                    </div>
                    <div className='col-lg-6 col-6 form-inline"'>
                      <label className=" font-weight-bold f3 text-warning">
                        :بۆ بەرواری{" "}
                      </label>
                    </div>
                  </div>
                </div>
                <div className="col-lg-3 col-4 form-inline">
                  <div className="row form-inline">
                    <div className="col-6 form-inline">
                      <p
                        className="font-weight-bold bg-white  f3"
                        style={{ color: "#000" }}
                      ></p>
                      <span style={{ color: "#2C3539" }}>:</span>
                      <p
                        className="font-weight-bold bg-white  f4"
                        style={{ color: "#000" }}
                      >
                        {QR_to}
                      </p>
                    </div>
                    <div className='col-lg-6 col-6 form-inline"'>
                      <label className=" font-weight-bold f3 text-warning">
                        :لە بەرواری{" "}
                      </label>
                    </div>
                  </div>
                </div>
                <div className="col-lg-4 col-4 mt3">
                  <div className="row">
                    <div className="col-lg-10 ">
                      <div className="row">
                        <div className="col-9">
                          <input
                            type="text"
                            name="QR_name"
                            value={QR_name}
                            onChange={AddProChange}
                            aria-label="Large"
                            className="form-control"
                          />
                        </div>
                        <div className="col-3">
                          <label className="text-warning f4 font-weight-bold">
                            گەڕان
                          </label>
                        </div>
                      </div>
                    </div>
                    <div className="col-lg-2 col-12">
                      <h3 className="font-weight-bold text-warning">
                        ڕاستەوخۆ
                      </h3>
                    </div>
                  </div>
                </div>
              </div>
            </>
          );
        }}
      </ProductConsumer>
    </>
  );
};

export default FillDetailQarzRastawxo;
